import Stars from "./Stars";

interface ReviewProps {
    name: string;
    text: string;
}
const Review = ({ name, text }: ReviewProps) => (
    <div className="flex w-full flex-col items-center gap-2 rounded-3xl bg-zing-neutral-cool-grey-800 p-4 text-center text-zing-12-18 female:bg-zing-neutral-cool-grey-200">
        <Stars size={16} />
        <div>{text}</div>
        <div className="text-zing-neutral-cool-grey-400 female:text-zing-neutral-cool-grey-600">
            — {name}
        </div>
    </div>
);

export default Review;
